import { FC } from 'react'
import { useQuery } from 'react-query'
import { Outlet } from 'react-router-dom'

import { CashierSessionsAPI } from '@api/cashierSessionsAPI'

import { CashierSessionStatusEnum } from '@models/cashierSession'

import { CashierSessionContext } from '@modules/cashier-session/contexts/CashierSessionContext'

import { QUERIES } from '@/constants/queries'

type Props = {}

const CashierLayout: FC<Props> = () => {
  const {
    data: cashierSession,
    isFetching,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [QUERIES.GET_CASHIER_SESSION_ACTIVE],
    queryFn: () => CashierSessionsAPI.getActive(),
    select: (response) => response.data?.cashier_session,
    cacheTime: 60 * 60 * 1,
  })

  const value = {
    hasCashierSession: !!cashierSession && cashierSession.status === CashierSessionStatusEnum.ACTIVE,
    cashierSession,
    isLoading: isLoading,
    isFetching: isFetching,
    refetchCashierSession: refetch,
  }

  return (
    <CashierSessionContext.Provider value={value}>
      <Outlet />
    </CashierSessionContext.Provider>
  )
}

export { CashierLayout }
